import { call, put, takeEvery } from 'redux-saga/effects'

import * as Api from '../api/project-templates-api';

function* fetchProjectTemplates(action) {
    try {
        const { templates, hasMore } = yield call(Api.fetchProjectTemplates, action.payload);
        yield put({
            type: 'PROJECT_TEMPLATES_FETCH_SUCCEEDED',
            payload: {
                templates,
                hasMore
            }
        });
    } catch (e) {
        yield put({
            type: 'PROJECT_TEMPLATES_FETCH_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* createProjectTemplate(action) {
    try {
        const template = yield call(Api.createProjectTemplate, action.payload.template);

        yield put({
            type: 'PROJECT_TEMPLATE_CREATE_SUCCEEDED',
            payload: {
                fragment: action.payload.template,
                template
            }
        });

        action.onComplete && action.onComplete(template);
    } catch (e) {
        yield put({
            type: 'PROJECT_TEMPLATE_CREATE_FAILED',
            payload: {
                name: action.payload.name,
                message: e.message || e,
                fragment: action.payload.template
            }
        });

        action.onError && action.onError(e);
    }
}

function* removeProjectTemplate(action) {
    try {
        yield call(Api.removeProjectTemplate, action.payload.templateId);
        yield put({
            type: 'PROJECT_TEMPLATE_REMOVE_SUCCEEDED',
            payload: {
                templateId: action.payload.templateId
            }
        });

        action.onComplete && action.onComplete();
    } catch (e) {
        yield put({
            type: 'PROJECT_TEMPLATE_REMOVE_FAILED',
            payload: {
                templateId: action.payload.templateId,
                message: e.message || e
            }
        });

        action.onError && action.onError(e);
    }
}

function* watchGetProjectTemplates() {
    yield takeEvery('PROJECT_TEMPLATES_FETCH_REQUESTED', fetchProjectTemplates);
}

function* watchCreateProjectTemplate() {
    yield takeEvery('PROJECT_TEMPLATE_CREATE_REQUESTED', createProjectTemplate);
}

function* watchRemoveProjectTemplate() {
    yield takeEvery('PROJECT_TEMPLATE_REMOVE_REQUESTED', removeProjectTemplate);
}

export default [watchGetProjectTemplates, watchCreateProjectTemplate, watchRemoveProjectTemplate];
